/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import styled from "@emotion/styled";
import { FaBell } from "react-icons/fa";
import useMediaQuery from "../hook/useMediaQuery";

const CustomButtonWrapper: any = styled.div`
  background-color: white;
  border: 1px solid #dddddd;
  border-radius: 6px;
  color: #555555;
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  padding: 12px;
  cursor: pointer;
  width: fit-content;
  height: 42px;
`;

const CustomButtonText = styled.div`
  font-size: 14px;
  font-weight: 600;
  text-align: left;
  letter-spacing: 0.7px;
  color: #555555;
  text-transform: uppercase;
  opacity: 1;
`;

const IconButton = styled.div`
  min-width: 42px;
  max-width: 42px;
  min-height: 42px;
  max-height: 42px;

  flex-shrink: 0;

  display: flex;
  align-items: center;
  justify-content: center;

  background: #fff;

  border-radius: 5px;
  border: 1px solid #dddddd;

  cursor: pointer;

  svg {
    width: 20px;
    height: 20px;

    color: #555555;
  }

  .tooltip-text {
    font-size: 14px;
    font-weight: 600;
    letter-spacing: 0px;
    color: #ffffff;
  }
`;

export default function WhatsNewButton() {
  const isLargerThan600 = useMediaQuery("(min-width: 600px)");

  if (isLargerThan600) {
    return (
      <CustomButtonWrapper className="loopedin-button">
        <FaBell width={12} height={12} size={12} />
        <CustomButtonText
          css={css`
            margin-left: 5px;
          `}
        >
          What's new
        </CustomButtonText>
      </CustomButtonWrapper>
    );
  }

  return (
    <IconButton className="loopedin-button">
      <FaBell />
    </IconButton>
  );
}
